import React, { Component } from 'react';
import { Row, Col, Tab } from 'react-bootstrap';
import Comments from 'components/Comments';
import { Checklist } from 'ctia-ui';
import { renderTabs, renderTabsContent } from 'helpers/RequestTabsHelper';

class VendorContent extends Component {
  state = { activeTab: 'deviceInfo' };

  handleTab = key => {
    this.setState({ activeTab: key });
  };

  render() {
    const { tabs, checkList } = this.props;

    return (
      <Tab.Container
        id="request-nav-tabs"
        defaultActiveKey={this.state.activeTab}
        onSelect={this.handleTab}
      >
        <Row className="clearfix">
          {renderTabs(tabs)}
          {renderTabsContent(tabs, this.state.activeTab)}
          <Col xs={12} sm={12} md={2}>
            <Checklist list={checkList} />
            <Comments />
          </Col>
        </Row>
      </Tab.Container>
    );
  }
}

export default VendorContent;



// WEBPACK FOOTER //
// ./src/containers/request/RequestContent/VendorContent.js